import React from 'react';

type Props = {
  className?: string;
};

/**
 * LightbulbSolid
 * Classic solid-fill lightbulb icon.
 */
const LightbulbSolid: React.FC<Props> = ({ className = 'w-12 h-12' }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7z" />
    <path d="M9 20h6v1.5H9zM10 22.5h4v1h-4z" opacity="0.8" />
  </svg>
);

export default LightbulbSolid;
